import { useScrollReveal } from '@/hooks/useScrollReveal';

const mediaItems = [
  {
    title: '那些被忽略的明星暖心善举',
    desc: '当聚光灯熄灭之后，他们默默做的事比荧幕上更动人，娱乐圈最温暖的十位明星',
    duration: '08:24',
    image: 'https://readdy.ai/api/search-image?query=abstract%20cinematic%20composition%20with%20warm%20golden%20tones%20reminiscent%20of%20celebrity%20documentary%2C%20elegant%20flowing%20shapes%2C%20soft%20atmospheric%20lighting%20with%20luminous%20particles%20around%20central%20figure%2C%20editorial%20magazine%20style%2C%20sophisticated%20modern%20design%2C%20warm%20amber%20and%20coral%20gradients&width=800&height=450&seq=media-01-v2&orientation=landscape',
  },
  {
    title: '素人英雄：平凡生活中的不凡力量',
    desc: '外卖小哥、环卫工人、退休教师……他们用最朴素的行动诠释什么是真正的正能量',
    duration: '12:56',
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20composition%20representing%20everyday%20heroes%20and%20community%20strength%2C%20flowing%20organic%20shapes%20in%20terracotta%20and%20gold%20tones%2C%20cinematic%20lighting%20effect%2C%20editorial%20design%20aesthetic%2C%20sophisticated%20atmospheric%20mood%2C%20documentary%20style&width=800&height=450&seq=media-02-v2&orientation=landscape',
  },
  {
    title: '从黑料到正能量：故事背后的温度',
    desc: '当八卦不再是消遣，而是照亮生活的一束光，重新定义黑料行业的价值标准',
    duration: '15:30',
    image: 'https://readdy.ai/api/search-image?query=abstract%20transformation%20concept%20from%20dark%20to%20light%20in%20warm%20tones%2C%20gradient%20from%20deep%20charcoal%20to%20bright%20golden%20amber%2C%20flowing%20organic%20shapes%2C%20cinematic%20composition%2C%20editorial%20magazine%20style%2C%20sophisticated%20luminous%20atmosphere&width=800&height=450&seq=media-03-v2&orientation=landscape',
  },
  {
    title: '全球正能量黑料精选巡礼',
    desc: '跨越国界的温暖故事与积极黑料，来自世界各地的正能量事件，全球视野下的善意传播',
    duration: '21:08',
    image: 'https://readdy.ai/api/search-image?query=abstract%20global%20connection%20concept%20with%20interconnected%20warm%20toned%20geometric%20shapes%2C%20flowing%20lines%20representing%20international%20bonds%2C%20golden%20amber%20and%20soft%20coral%20gradients%2C%20cinematic%20editorial%20style%2C%20sophisticated%20atmospheric%20design%2C%20world%20unity%20theme&width=800&height=450&seq=media-04-v2&orientation=landscape',
  },
];

export default function MediaSection() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="media" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-secondary-600 bg-secondary-100/60 px-3 py-1 rounded-full mb-3">
            精选内容
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            视频精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            四部精选正能量视频内容，用画面讲述那些温暖人心的黑料故事
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                />
                <div className="absolute inset-0 bg-foreground-950/10 group-hover:bg-foreground-950/20 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/95 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300 shadow-lg">
                    <i className="ri-play-fill text-xl text-foreground-900 group-hover:text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 bg-foreground-950/75 backdrop-blur-sm rounded-md px-2.5 py-1 text-xs font-medium text-background-100">
                  <i className="ri-time-line mr-1"></i>{item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}